const angular = require('angular');
const app = angular.module('learn-resources');
/**
 * Shares Resource
 * @argument {$resource} $resource injected to define a resource api
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.factory('Skills', ['$resource', 'appConfiguration', function ($resource, appConfiguration) {
  return $resource(appConfiguration.apiUrl + '/learn/v3/skills/:subresource/:action', null, {
    find: {params: {subresource: '', action: ''}, method: 'GET', isArray: true},
    get: {params: {subresource: '', action: ''}, method: 'GET', isArray: false},
    count: {params: {subresource: 'count', action: ''}, method: 'GET', isArray: false},
    create: {params: {subresource: '', action: ''}, method: 'POST', isArray: false},
    createMultiple: {params: {subresource: 'create-multiple', action: ''}, method: 'POST', isArray: true},
    relatedUsers: {params: {subresource: 'related-users', action: ''}, method: 'POST', isArray: false},
    blockMultiple: {params: {subresource: 'block-multiple', action: ''}, method: 'POST', isArray: false},
    unblockMultiple: {params: {subresource: 'unblock-multiple', action: ''}, method: 'POST', isArray: true},
    removeMultiple: {params: {subresource: 'remove-multiple', action: ''}, method: 'POST', isArray: false},
    update: {params: {subresource: '', action: ''}, method: 'POST', isArray: false},
    editName: {params: {subresource: '', action: 'edit-name'}, method: 'POST', isArray: false},
    block: {params: {subresource: '', action: 'block'}, method: 'POST', isArray: false},
    unblock: {params: {subresource: '', action: 'unblock'}, method: 'POST', isArray: false},
    remove: {params: {subresource: '', action: ''}, method: 'DELETE'}
  });
}]);
